module.exports = __webpack_public_path__ + "static/media/zoom_map_plus.b4b14530.svg";